import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import downloadFile from '~/utils/downloadFile';
import { useSelector } from 'react-redux';
import * as S from '../styles';
import TeamSection from '../components/TeamsSection';
import ArbitrationSection from '../components/ArbitrationSection';

export default function ArbitrationTeam({ publicFiles, ...props }) {
  const { t } = useTranslation();
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  const [pdfLoading, setPdfLoading] = useState(false);

  return (
    <S.Container>
      <S.ContainerTeam>
        <S.Scroller>
          <TeamSection {...props} />
        </S.Scroller>
      </S.ContainerTeam>
      <S.ContainerArbitration>
        <S.Scroller>
          <ArbitrationSection {...props} />
        </S.Scroller>
      </S.ContainerArbitration>
      <S.DownloadPDFButton
        onClick={() => {
          if (publicFiles.data.referee)
            downloadFile(publicFiles.data.referee.id, setPdfLoading);
        }}
        disabled={
          Object.keys(publicFiles.data).length === 0 ||
          !publicFiles.data.referee
        }
        text={t('downloadRefereeDesignation')}
        loading={pdfLoading}
        competition={match?.competitionId}
      />
    </S.Container>
  );
}

ArbitrationTeam.propTypes = {
  publicFiles: PropTypes.object,
};

ArbitrationTeam.defaultProps = {
  publicFiles: { data: {} },
};
